import { useMemo } from "react";
import { keyBy } from "lodash";
import apiClient from "./apiClient";
import { ENDPOINTS } from "./endpoints";
import { useQuery } from "@tanstack/react-query";
import queryKeys from "../queryKeys";

export const fetchRegions = async () => {
    const result = await apiClient.get(ENDPOINTS.regions);
    return result?.data;
};

export const useFetchRegions = ({ isEnabled = true, ...options } = {}) => {
    const { data, isFetched, ...rest } = useQuery({
        queryKey: queryKeys.regions(),
        queryFn: fetchRegions,
        enabled: isEnabled,
        refetchOnMount: false,
        ...options,
    });

    const regionsById = useMemo(() => keyBy(data, "region_id"), [data]);

    return { data, isFetched, regionsById, ...rest };
};
